var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.getting),expression:"getting"}],staticClass:"chart-ring",style:({
    height: _vm.height + 'px'
  }),attrs:{"element-loading-background":_vm.loadingBackColor}},[(_vm.option)?_c('ChartContainer',{ref:"chartInstance",staticClass:"chart-pie",attrs:{"option":_vm.option}}):_c('el-empty',{attrs:{"description":"暂无数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }